module.exports = __webpack_public_path__ + "img/trip_20.d8377d1d.jpg";